<div class="dialog-width">
  <button class="close-button" mat-icon-button [mat-dialog-close]="false">
    <mat-icon>close</mat-icon>
  </button>

  <h1 mat-dialog-title>{{ "register" | translate }}</h1>
  <div mat-dialog-content>
    <form [formGroup]="formGroup">
      <mat-form-field>
        <mat-label>{{ "mail" | translate }}</mat-label>
        <input type="email" matInput formControlName="email" />
        <mat-icon matPrefix>mail</mat-icon>
        <mat-error>Invalid email address format</mat-error>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "name" | translate }}</mat-label>
        <input matInput formControlName="firstname" />
        <mat-icon matPrefix>edit</mat-icon>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "surname" | translate }}</mat-label>
        <input matInput formControlName="lastname" />
        <mat-icon matPrefix>edit</mat-icon>
      </mat-form-field>

      <mat-form-field *ngIf="mode === opModes.Create">
        <mat-label>{{ "password" | translate }}</mat-label>
        <input type="password" matInput formControlName="password" />
        <mat-icon matPrefix>vpn_key</mat-icon>
      </mat-form-field>

      <mat-form-field *ngIf="mode === opModes.Create">
        <mat-label>{{ "confirm-password" | translate }}</mat-label>
        <input type="password" matInput formControlName="confirmPassword" />
        <mat-icon matPrefix>vpn_key</mat-icon>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "choose-municipality" | translate }}</mat-label>
        <mat-select formControlName="municipalitiesCtr" multiple>
          <mat-option [value]="defaultGuid" (onSelectionChange)="selectAllMunicipalities()">
            {{ 'all-municipalities' | translate }}
          </mat-option>
          <mat-option *ngFor="let municipality of municipalities" [value]="municipality.id">
            {{ municipality.name }}</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field>
        <mat-label>{{ "choose-category" | translate }}</mat-label>
        <mat-select formControlName="categories" multiple>
          <mat-option [value]="defaultGuid" (onSelectionChange)="selectAllCategories()">
            {{ 'all-categories' | translate }}
          </mat-option>
          <mat-option *ngFor="let category of categories" [value]="category.id">
            {{ getCategoryDescription(category.name) }}</mat-option>
        </mat-select>
      </mat-form-field>
    </form>

  </div>
  <div mat-dialog-actions align="end">
    <button class="full-width" mat-raised-button color="primary" [disabled]="!formGroup.valid" (click)="register()"
      cdkFocusInitial>
      {{ btnLabel | translate }}
    </button>
  </div>
</div>
